import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { ListPaymentsQuery, PaymentList } from '@klopotun/contracts';
import { paymentQueries } from './payment-queries.js';

export const usePaymentsQuery = (query?: ListPaymentsQuery): UseQueryResult<PaymentList> =>
  useQuery(paymentQueries.list(query));
